import { Paths } from "@ea/shared_types/next/ea.utils.types";

export function createFieldNameGetter<T>() {
  return (path: Paths<T>): string => {
    // eslint-disable-next-line
    return path as any;
  };
}
